module.exports = __webpack_public_path__ + "static/media/candace.ea629673.jpg";